import { Store } from 'utils';

const PAGE_SIZE = 20;
const PAGE_ITEMS = 3;
const PAGE_OFFSET = 1;

class Resumes extends Store {

	constructor()
	{
		super();
	}

	getInitialState() {
		return {
			all: [],
			resumes: [],
			ready: false,
			page: 0,
			pageCount: 0,
			total: 0,
			loading: true,
			firstPage: 0,
			lastPage: 0,
			qualifications: null,
			selected: [],
            success:false,
            successSaveInvitation: false,
            minimize:false,
            loadingRemove: false,
            resumesRemoved:[],
			count: 20
		}
	}

    onResumeRemove(state, data) {
         var a = data.resumes.map(function(item) {
            for (var i = 0; i < state.selected.length; i++) {
                if(state.selected[i].id === item.id) {
                    state.resumesRemoved.push(item.id);
                }
            }
        });

        state.resumesRemoved = state.resumesRemoved;
    }

    onHideMessageUsersRemove(state){
        state.resumesRemoved = [];
    }

	onMinimizePanel(state){
	    if(state.minimize == false)
        {
            state.minimize = true;
        }
        else
        {
            state.minimize = false;
        }

    }

    // onShowSuccess(state) {
	 //    state.success = true;
    //     this.resetSelection(state)
    //     state.loading = false;
    // }
    onHideSuccess(state) {
        state.success = false;
        state.loading = false;
    }

    onShowSuccessSaveInvitation(state) {
        state.successSaveInvitation = true;
        state.loading = false;

    }
    onHideMessageSavedInvitation(state) {
        state.successSaveInvitation = false;
        state.loading = false;
    }

	onResumeChanged(state, data) {
		/*
		 * Ako nemamo pravo pogledati profil, servis ce vratiti
		 * forbidden = true zastavicu. Stoga nije potrebno 
		 * selektirati profil.
		 */
		if (data.forbidden) {
			return;
		}

		/*
		 * Kod pregleda pojedinacnog profila, deselektiraj sve
		 * osim profila kojeg trenutno pregledavamo, kako bi
		 * isti bio oznacen nakon sto se navigiramo natrag
		 * na ekran za pretrazivanje profila.
		 */
		state.resumes = state.resumes.map(function(item) {
			if(item.checked == true) {
				item = Object.assign({}, item);
				item.checked = false;
			}

			if(item.id == data.resume.id) {
				item = Object.assign({}, item);
				item.checked = true;
			}

			return item;
		});

		state.selected = [data.resume];
	}

	findSelectedResumes(state) {
		return state.resumes.filter(function(item) {
			return item.checked == true;
		});
	}

	onQualificationsChanged(state, data) {
		var q = {};

		data.qualifications.map(function(item) {
			return q[item.key] = item.value;
		});

		state.qualifications = q;

	}

	onPageChanged(state, data) {

		if(data.page <= 0) {
			state.page = 0;
		} else if(data.page >= state.pageCount) {
			state.page = state.pageCount - 1;
		} else {
			state.page = data.page;
		}

		state.firstPage = Math.max(0, state.page - PAGE_OFFSET);
		state.lastPage = Math.min(state.pageCount, state.firstPage + PAGE_ITEMS);
	}

	onCountChanged(state, data) {
		let pageNum = (state.page * state.count) / parseInt(data);

		state.page = parseInt(pageNum);
		state.firstPage = Math.max(0, state.page - PAGE_OFFSET);
		state.lastPage = Math.min(state.pageCount, state.firstPage + PAGE_ITEMS);

		state.count = data;
	}

	onResumesLoading(state) {
		state.loading = true;
	}

	onResumesReady(state) {
		state.loading = false;
		state.ready = true;
	}

	resetSelection(state) {
        state.selected = [];
    }

    isSelected(id) {
	    var selected = false;

	    this.getState().selected.forEach((item) => {
	        if(item.id == id) {
	            selected = true;
            }
	    });

	    return selected;
    }

	onResumesChanged(state, data) {
		state.all = data.resumes;
		state.resumes = data.resumes;

		state.total = data.total;
		state.pageCount = Math.ceil(data.total / state.count);

		state.firstPage = Math.max(0, state.page - PAGE_OFFSET);
		state.lastPage = Math.min(state.pageCount, state.firstPage + PAGE_ITEMS);

		state.loading = false;

		this.resetSelection(state);
	}

	getQualificationFormater() {
		var state = this.getState();

		if(state.qualifications == null) {
			return new KeyFormatter();
		} else {
			return new QualificationFormatter(state.qualifications);
		}
	}

	getPages() {
		var pages = [];
		var { firstPage, lastPage } = this.getState();
		var page = this.getState().page;

		for(var i=firstPage; i<lastPage; i++) {
			pages.push({
				page: i,
				active: i == page
			});
		}

		return pages;
	}

	onAddFilter(state) {
		state.loading = true;
		state.page = 0;
	}

	onRemoveFilter(state) {
		state.loading = true;
		state.page = 0;
	}

	onClearFilters(state) {
		state.loading = true;
		state.page = 0;
	}

	onResumeSelected(state, data) {
		state.resumes = state.resumes.map(function(item) {
			if(item.id == data.resume.id) {
				item = Object.assign({}, item);
				item.checked = data.selected;
			}

			return item;
		});

		state.selected = this.findSelectedResumes(state);
	}

	onSelectAll(state, data) {
		state.resumes = state.resumes.map(function(item) {
			var item = Object.assign({}, item);
			item.checked = data.status;
			return item;
		});

		state.selected = this.findSelectedResumes(state);
	}

	getSelectAllStatus() {
		var { resumes } = this.getState();
		return resumes.length == this.getSelectedCount();
	}

	getSelected() {
		return this.getState().selected;
	}

	getSelectedCount() {
		return this.getState().selected.length;
	}
    onRemoveAllSelection(state){
        state.resumes = state.resumes.map(function(item) {
            var item = Object.assign({}, item);
            item.checked = false;
            return item;
        });
        state.loadingRemove = true;

        state.selected = this.findSelectedResumes(state);
    }
    onResetLoadingRemove(state) {
        state.loadingRemove = false;
    }
}

class QualificationFormatter {

	constructor(qualifications)
	{
		this.qualifications = qualifications;
	}

	format = (key) => {
		return this.qualifications[key];
	}
}

class KeyFormatter {
	format = (key) => {
		return key;
	}
}



const store = new Resumes();
export default store;



// WEBPACK FOOTER //
// ./src/modules/model/Resumes.js